import userResource from "@/shared/resource/user";
import axios from "axios";
import { authorizedAxios } from "./authorizedAxios";
import {
    SimpleUser,
    EmployerUser,
    SearchResultUser,
    UserDetails,
    PrivateCipInfo,
    CipPostResult,
    UserCreateResponse,
    ChangeUserRoleParams,
    CreateEmployerUserParams,
    EmployerCreateResponse,
    EmployerUserWithEmailFailure,
    PartnerUser,
    PartnerUserSaveResponse,
    PartnerUsersResponse,
    PartnerUserRequest,
    ContactInformation,
    FamilyMember,
    FamilyUpdateRequest,
    IndividualSignup,
    PlanDetails,
    ContributionLimitResponse,
    UserPlanTypeUpdate,
    UserPlanType,
    CognitoTokens,
    SortOrder,
    EmployeeListSortOption,
    BirthYearResponse,
    PartnerHsaStoreInfo,
    RevealPersonalInformationRequest,
    RevealPersonalInformationResponse,
    MfaStatusEnum,
    PartnerEmailResponse,
    MfaUserDisableRequest,
    EmployerRolePermission,
    CommunicationKitType,
    RolePermissionsResponse,
    UserRoleModel,
    ReportCategory,
    QuickSightReport,
    QuickSightUserReportsApiResponse,
    AddEmployeeGroupRequest,
    SigningDocument,
    DocumentSignature,
    DocumentSaveSignatureRequest,
    UserPartnerSettings,
    CommunicationPortal,
    FundingOptionResponse,
    AssetType,
    EnrollmentOptionResponse,
    OutageNotification,
    ImpersonationInitiateData,
    ClaimHsabAccountRequest,
    PartnerSettingsRequest,
    PartnerSettingsResponse,
    UserAccountCredentialsResponse,
    IdpStatusChangeRequest,
    OktaFactor,
    OktaEnrollFactorResponse,
    OktaAccountCheckResponse,
    ForgotUsernameRequest,
    ForgotUsernameResponse,
    UsernameValidateRequest,
    IdentityProofingOptionsResponse,
    IdentityProofChallengeRequest,
    IdentityProofChallengeResponse,
    IdentityProofVerifyRequest,
    UserContactVerifiedResponse,
    HsabSsoDestination,
    ResyncTalonClaimsRequest,
    OktaEnrollFactorRequest,
    SupportInfo,
    SearchCapability,
    HsabSsoLocationResponse,
    Address,
    LobAddressValidationResponse,
    OktaFactorType,
    OktaRevertFactorRequest,
    MobileAppSearchRequest,
    MobileAppSearchResponse,
    MobileApp,
    MfaEmailChallengeRequest,
    MfaEmailChallengeResponse,
    IdentityProofDataVerifyRequest,
    MfaEmailVerifyRequest,
    IdpEmailChangeRequest,
    VerifyIdpEmailChangeRequest,
    PasswordChangeRequest,
    PartnerShowEmployerSignupQuestion,
    EbtoRequest,
    EbtoEmailRequest,
    EbtoCampaign,
    EbtoResponse,
    EbtoUserFinalizeRequest,
    EbtoVerifyUserRequest,
    HsabPlanType,
    CommunicationDashboard,
    CommunicationClient,
    EplResponse,
    EplLookupMethod,
    ScannerLicenseResponse,
    LogEmployeeLoginRequest,
    MobileAppVersion,
    UserFeedbackTriggerModel,
    UserFeedbackSaveRequest,
    MobileAppAccessCheckResponse,
    FileUploadCategoryResponse,
    FileUploadCategory,
    FileUploadResponse,
    UserSearchDocument,
    EmployerSearchDocument,
    HsaBankSsoLocationName,
    LobAutoCompleteAddressRequest,
    LobAddressValidationRequest,
    OtherHsaAmountModel,
    UserCoverageLevels,
    UserCoverageLevelUpdateResponse,
    HsabEmailChangeRequest,
    HsabEmailChangeResponse,
    HsabEmailChangeVerifyRequest,
    HsabEmailChangeVerifyResponse,
    AdminPortalUser,
    SearchAdminUsers,
    AdminUserResponse,
    AdminUserStatusChangeRequest,
    UserMfaOptions,
    UserInterestRates,
    EmploymentStatus,
    EmployerActiveFeeSchedules,
    IndividualEmailVerifyRequest,
    IndividualEmailVerifyResponse,
    IndividualLoginAccountRequest,
    CountryList,
    UserDiscretionaryData,
    UserTermsType,
    UserPersonalInfo,
    ImportantDateRequest,
    BalanceTransferFormResponse,
    TrusteeToTrusteeBalanceTransferFormRequest,
    RolloverBalanceTransferFormRequest,
    PartnerBanner,
    UpdatePartnerBannerOrderRequest,
    DisplayDefaultBannersRequest,
    PlanSetting,
    HSARepResponse
} from "@/shared/types";

import {
    Communication,
    SaveCommunication,
    Employee,
    EmployeeListResult,
    EmployeeSearchTerm,
    ProfileInformation,
    PartnerEmployersResponse,
    UpdateCensusManagerRequest,
    EmployerDashboard,
    EmployerInviteDateRequest,
    EmployeeSearchResults,
    EmployeeSearchDropdownItem,
    EmployerCensusFileResponse,
    EmployerCensusFileDetailsResponse,
    FundingOptionRequest,
    EnrollmentOptionRequest,
    EmployeeIdFileResponse,
    EmployeeListSearchFields,
    PartnerEmployerList,
    PartnerEmployersSearchFields,
    PartnerEmployer,
    LoginHistoryResponse,
    EmployerTypeAheadResponse,
    UserNotesResponse,
    UserEmploymentInfo,
    EmployerFeeScheduleResponse,
    WexEmployerProfile,
    EmployerProfileResponse,
    EmployerProfileUpdateResponse,
    EmployerProfileRequest
} from "@/employer/types";

import {
    EmployerListResult,
    EmployerSearchResult,
    EmployerActivationRequest,
    PartnerSave,
    PartnerSaveResponse,
    Employer,
    AccountEnableDisableRequest,
    CognitoAccountEnableDisableResult,
    SalesPerson,
    TerminationReason,
    MfaAdminDisableRequest,
    EmployerStatusChangeRequest,
    UserDobNameModel,
    PartnerGetResponse,
    ResetUserCustodianRequest,
    AdminSftpTestFilesList,
    AdminSftpTestFileDownload,
    UserSearchResultList,
    UserSearchResultModel,
    TestUser,
    EmploymentStatusResponse,
    PartnerContentType,
    CampaignDataModel,
    EbtoEmployerSearchResult,
    OpenSearchIndex,
    OpenSearchIndexRequest,
    OpenSearchPackagesResponse,
    OpenSearchDomainDetail,
    StateMachineExecutionHistory,
    CreateTransferOutCampaignRequest,
    SsoUserSyncStatusModel,
    EmailTemplate,
    EmailTemplateDetail,
    PartnerUserBulkResponse, BulkFileUploadStatus,
    PartnerBannerDraft,
    NewPartnerBanner,
} from "@/admin/types";

export interface WizardState {
    wizardProgressSteps: WizardStep[];
    currentStep: number;
    wizardComplete: boolean;
}

export interface WizardStep {
    wizardStepNumber: number;
    wizardStepName: string;
}

export interface SignupEmployerRequest {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    companyName: string;
}

export enum InvitationType {
    Admin,
    Employer
}

export interface CreateUserRequest {
    firstName: string;
    lastName: string;
    email: string;
    type: InvitationType;
    phone?: string;
    companyName?: string;
    employerId?: number;
}

export interface UserWizardState {
    wizardProgressSteps: UserWizardStep[];
    currentStep: number;
    wizardComplete: boolean;
}

export interface UserWizardStep {
    wizardStepNumber: number;
    wizardStepName: string;
    hasUserCompleted: boolean;
    order: number;
}

export interface CreateAdminUserRequest {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    username: string;
    employeeId?: number;
    assignedRoles: number[];
}
export interface UpdateAdminUserRequest {
    userId: number;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    username: string;
    employeeId?: string;
    existingUserName: string;
    existingStatus: string;
    assignedRoles: number[];
}

export interface MetricContent {
  showTab: boolean;
  showMetrics: boolean;
  name: string;
  crossSellTitle: string | null;
  crossSellImageAltText: string | null;
  crossSellDescription: string | null;
  crossSellMoreInfoUrl: string | null;
  crossSellImageUrl: string | null;
  metrics: Metric[];
}

export interface Metric {
  label: string;
  value: string | number;
}

export function createUser (request: CreateUserRequest) {
    const invitationType: string = request.type === InvitationType.Admin ? "admin" : "employer";

    return authorizedAxios.post<UserCreateResponse>(userResource.createUser(), {
        employerName: request.companyName,
        email: request.email,
        firstName: request.firstName,
        lastName: request.lastName,
        phone: request.phone,
        employerId: request.employerId,
        invitationType
    });
}

export function markUserAsVerified (username: string) {
    return authorizedAxios.post(userResource.markUserAsVerified(username));
}

export function searchForUserByEmail (email: string) {
    return authorizedAxios.get<SearchResultUser[]>(userResource.searchUserByEmail(email));
}

export function signupEmployer (request: SignupEmployerRequest) {
    return createUser({ ...request, type: InvitationType.Employer });
}

export function getUserAccountsForEmployer (employerId: number) {
    return authorizedAxios.get<EmployerUser[]>(userResource.getEmployerUsers(employerId));
}

export function resendUserActivationLink (userId: number, employerId: number) {
    return authorizedAxios.post(userResource.resendUserActivation(userId, employerId));
}

export function deleteEmployerUser (userId: number, employerId: number) {
    return authorizedAxios.delete(userResource.deleteEmployerUser(userId, employerId));
}

export function resendPartnerUserActivationLink (partnerId: number, inviteId: number) {
    return authorizedAxios.post(userResource.resendPartnerUserActivation(partnerId, inviteId));
}

export function partnerUserForgotPassword (partnerId: number, email: string) {
    return authorizedAxios.post(userResource.partnerUserForgotPassword(partnerId), { email });
}

export function partnerUserDisableMfa (partnerId: number, email: string) {
    return authorizedAxios.post(userResource.partnerUserDisableMfa(partnerId), { email });
}

export function getUser (username?: string, partnerId?: number) {
    const query = (username) ? { forUser: username, forUserPartnerId: partnerId } : undefined;
    return authorizedAxios.get<UserDetails>(userResource.getUser(), query);
}

export function getSimpleUser (partnerId: number, username: string) {
    return authorizedAxios.get<SimpleUser>(userResource.getSimpleUser(partnerId, username));
}

export function logEmployeeHsaStoreClick () {
    return authorizedAxios.post(userResource.logHsaStoreClick());
}

export function logEmployeeHsaBlueBookClick () {
    return authorizedAxios.post(userResource.logHsaBlueBookClick());
}

export function logEmployeeExpenseAttachmentUploaded () {
    return authorizedAxios.post(userResource.logExpenseAttachmentUploaded());
}

export function logEmployeeLogin (request: LogEmployeeLoginRequest) {
    return authorizedAxios.post(userResource.logEmployeeLogin(), request);
}

export function logEmployerAccess (employerId?: number, partnerId?: number) {
    const query = { employerId, partnerId };
    return authorizedAxios.post(userResource.logEmployerAccess(), query);
}

export function logHsaStoreWidget (isDefaultLink: boolean) {
    return authorizedAxios.post(userResource.logHsaStoreWidget(isDefaultLink));
}

export function changeUserRole (changeArguments: ChangeUserRoleParams) {
    const { employerUserId, employerId, userRoles } = changeArguments;
    const putBody = { roles: userRoles };
    const url = userResource.putEmployerUser(employerId, employerUserId);

    return authorizedAxios.put<EmployerUser>(url, putBody);
}

export function addEmployerUser (addArguments: CreateEmployerUserParams) {
    const postBody = addArguments;
    const url = userResource.postEmployerUser(addArguments.employerId);
    return authorizedAxios.post<EmployerUserWithEmailFailure>(url, postBody);
}

export function saveProfileInformation (request: ProfileInformation) {
    return authorizedAxios.put(userResource.profileInformation(request.employerId), request);
}

export function saveFundingOption (employerId: number, request: FundingOptionRequest) {
    return authorizedAxios.put(userResource.fundingOption(employerId), request);
}

export function getFundingOption (employerId: number) {
    return authorizedAxios.get<FundingOptionResponse>(userResource.fundingOption(employerId));
}

export function getFundingOptionHistory (employerId: number) {
    return authorizedAxios.get<FundingOptionResponse[]>(userResource.fundingOptionHistory(employerId));
}

export function saveEnrollmentOption (employerId: number, request: EnrollmentOptionRequest) {
    return authorizedAxios.put(userResource.enrollmentOption(employerId), request);
}

export function getEnrollmentOption (employerId: number) {
    return authorizedAxios.get<EnrollmentOptionResponse>(userResource.enrollmentOption(employerId));
}

export function getEmployeesList (employerId: number,
                                  pageNumber: number,
                                  pageSize: number,
                                  sortOption: EmployeeListSortOption,
                                  sortOrder: SortOrder,
                                  searchTerm: EmployeeListSearchFields) {
    return authorizedAxios.post<EmployeeListResult>
    (userResource.employeesList(employerId), {pageNumber, pageSize, sortOption, sortOrder, searchTerm})
        .then(originalObject => {
            const data = originalObject.data;
            return {
                ...data,
                pageNumber
            };
        });
}

export function getProfileInformation (employerId: number) {
    return authorizedAxios.get<ProfileInformation>(userResource.profileInformation(employerId));
}

export function getEmployeeInformation (employerId: number, employeeId: number) {
    return authorizedAxios.get<Employee>(userResource.getEmployeeInformation(employerId, employeeId));
}

export function saveEmployeeInformation (request: Employee) {
    return authorizedAxios.put<Employee>(userResource.saveEmployeeInformation(request.employerId), request);
}

export function cancelEmployeePlanUpdate (request: Employee) {
    return authorizedAxios.post<Employee>(userResource.cancelEmployeePlanUpdate(request.employerId), request);
}

export function getEmployerSearch (page: number, pageSize: number,
                                   searchTerm: string, partnerId: number, includeTerminated: boolean) {
    return authorizedAxios.get<EmployerSearchResult>(userResource.getEmployerSearch(),
        {page, pageSize, searchTerm, partnerId, includeTerminated});
}
export function activateEmployer (request: EmployerActivationRequest) {
    return authorizedAxios.put(userResource.activateEmployer(request.employerId), request);
}

export function terminateEmployer (request: EmployerStatusChangeRequest) {
    return authorizedAxios.put(userResource.terminateEmployer(request.employerId), request);
}

export function cancelScheduledTermination (employerId: number) {
    return authorizedAxios.post(userResource.cancelScheduledTermination(employerId));
}

export function reactivateEmployer (request: EmployerStatusChangeRequest) {
    return authorizedAxios.put(userResource.reactivateEmployer(request.employerId), request);
}

export function claimExistingUser (verificationCode: string, lastFour: string, dob: string, email: string) {
    const url = userResource.employeeClaimBegin(verificationCode);
    const requestBody = {
        ssnLastFour: lastFour,
        dateOfBirth: dob,
        emailAddress: email
    };
    return authorizedAxios.post(url, requestBody);
}

export function claimEmployeeBegin (verificationCode: string, lastFour: string, dob: string, preferredEmail: string) {
    const url = userResource.employeeClaimBegin(verificationCode);
    const requestBody = {
        ssnLastFour: lastFour,
        dateOfBirth: dob,
        emailAddress: preferredEmail
    };

    return axios.post<{
        cognitoUsername: string;
        temporaryPassword: string;
        isEmailMatch: boolean;
    }>(url, requestBody);

}

export function recoverUser (emailAddress: string) {
    return axios.post(userResource.recoverUser(), { emailAddress });
}

export function listFamilyMembers (args?: { username: string, partnerId: number }) {
    const params = args ? { forUser: args.username, forUserPartnerId: args.partnerId } : undefined;
    return authorizedAxios.get<FamilyMember[]>(userResource.family(), params);
}

export function getFamilyMemberById (familyMemberId: number) {
    return authorizedAxios.get<FamilyMember>(userResource.familyMember(familyMemberId));
}

export function updateFamily (update: FamilyUpdateRequest) {
    return authorizedAxios.put<FamilyUpdateRequest>(userResource.family(), update);
}

export function deleteFamilyMemberById (id: number) {
    return authorizedAxios.delete(userResource.familyMember(id));
}

export function addFamilyMember (familyMember: FamilyMember) {
    return authorizedAxios.post<FamilyMember>(userResource.family(), familyMember);
}

export function updateFamilyMember (id: number, familyMember: FamilyMember) {
    return authorizedAxios.put<FamilyMember>(userResource.familyMember(id), familyMember);
}

export function claimEmployeeEnd (verificationCode: string) {
    return authorizedAxios.post(userResource.employeeClaimEnd(verificationCode));
}

export function claimEmployeeAddEmployeeGroupToUser (request: AddEmployeeGroupRequest) {
    return authorizedAxios.post(userResource.employeeClaimAddEmployeeGroupToUser(), request);
}

export function getEmployerEarliestInviteDate (employerId: number) {
    return authorizedAxios.get(userResource.earliestInviteDate(employerId));
}

export function updateEmployerEarliestInviteDate (employerId: number, request: EmployerInviteDateRequest) {
    return authorizedAxios.put(userResource.earliestInviteDate(employerId), request);
}

export function getUsStates () {
    return authorizedAxios.get(userResource.getUsStates());
}

export function getWizardState (employerId: number) {
    return authorizedAxios.get<WizardState>(userResource.wizardState(employerId));
}

export function setWizardComplete (employerId: number) {
    return authorizedAxios.put(userResource.wizardState(employerId));
}

export function resendEmployeeInviteLink (employerId: number, employeeId: number) {
    return authorizedAxios.post(userResource.resendEmployeeInviteLink(employerId, employeeId));
}

export function postAgreedTerms (document: string, termsType: UserTermsType) {
    return authorizedAxios.post(userResource.userTermsAndConditions(), { termsIdentifier: document, termsType });
}

export function GetAcceptedUserTermsAndConditions () {
    return authorizedAxios.get(userResource.getAcceptedUserTermsAndConditions());
}

export function postIndividualSignupCip (accountSetupInfo: PrivateCipInfo) {
    return authorizedAxios.post<CipPostResult>(userResource.individualSignupCip(), accountSetupInfo);
}

export function putUserEmployerName (employerName: string) {
    return authorizedAxios.put(userResource.putUserEmployerName(), {employerName});
}

export function getEmployeeClaim (claimLinkId: string) {
    return authorizedAxios.get(userResource.employeeClaimBegin(claimLinkId));
}

export function getEmployeeEmailAvailabilityByClaim (verificationCode: string, email: string) {
    return axios.get(userResource.employeeClaimCheckEmailAvailability(), {
        params: {
            verificationCode,
            email
        }});
}

export function getPersona () {
    return authorizedAxios.get<{persona: string}>(userResource.persona()).then(response => <string>(response.data.persona));
}

export function setPersona (persona: string) {
    return authorizedAxios.put(userResource.persona(), { persona });
}

export function getContactInformation (username: string, partnerId: number) {
    const data = (username) ? { forUser: username, forUserPartnerId: partnerId } : undefined;
    return authorizedAxios.get<ContactInformation>(userResource.contactInformation(), data);
}

export function getContactInformationAdmin (username: string, partnerId: number) {
    const data = (username) ? { forUser: username, forUserPartnerId: partnerId } : undefined;
    return authorizedAxios.get<ContactInformation>(userResource.contactInformationAdmin(), data);
}

export function setContactInformation (request: ContactInformation) {
    return authorizedAxios.put(userResource.contactInformation(), request);
}

export function updateUserProfile (request: ContactInformation) {
    return authorizedAxios.put<ContactInformation>(userResource.userProfile(), request);
}

export function TermsAccepted () {
    return authorizedAxios.post(userResource.termsAccepted());
}

export function postEmployerCensusFile (file: any, employerId: number) {
    return authorizedAxios.postFiles(userResource.employerCensusUpload(employerId),
        [file]
    );
}

export function getUserWizardProgress () {
    return authorizedAxios.get<UserWizardState>(userResource.userWizardProgress());
}

export function getEmployerById (employerId: number) {
    return authorizedAxios.get<Employer>(userResource.employer(employerId));
}

export function putEmployerById (employerId: number, employer: Employer) {
    return authorizedAxios.put<Employer>(userResource.employer(employerId), employer);
}

export function setUserWizardComplete (wizardStepNumber: number) {
    return authorizedAxios.put(userResource.userWizardProgressComplete(wizardStepNumber));
}

export function setEmployerWizardProgressComplete (employerId: number, wizardStepNumber: number) {
    return authorizedAxios.put(userResource.employerProgressComplete(employerId, wizardStepNumber));
}

export function getInitialContribution () {
    return authorizedAxios.get(userResource.initialAnnualContribution());
}

export function getEmployerDashboard (employerId: number) {
    return authorizedAxios.get<EmployerDashboard>(userResource.employerDashboard(employerId));
}

export function verifyEmailChange (verifyLinkId: string): any {
    return authorizedAxios.post(userResource.verifyEmailChange(), { verifyLinkId });
}

export function getUserAccountAlerts () {
    return authorizedAxios.get(userResource.userAccountAlerts());
}

export function setUserAccountAlertsRead (messageIds: number[]) {
    return authorizedAxios.post(userResource.userAccountAlerts(), { messageIds });
}

export function deleteUserAccountAlert (notificationId: number) {
    return authorizedAxios.post(userResource.deleteUserAccountAlert(notificationId));
}

export function getInitiateImpersonationResponse (token: string) {
    return axios.get<ImpersonationInitiateData>(
        userResource.getInitiateImpersonationResponse(), { params: { token }});
}

export function getImpersonationUrl (targetCognitoUsername: string, partnerId: number) {
    return authorizedAxios.get<string>(
        userResource.getImpersonationUrl(targetCognitoUsername, partnerId));
}

export function createIndividualSignup (request: IndividualSignup) {
    return authorizedAxios.post<UserCreateResponse>(userResource.createIndividualSignup(), request);
}

export function verifyIndividualSignupEmail (request: IndividualEmailVerifyRequest) {
  return authorizedAxios.post<IndividualEmailVerifyResponse>(userResource.verifyIndividualSignup(), request);
}

export function resendIndividualSignupEmail (email: string) {
    return authorizedAxios.post(userResource.resendIndividualSignup(), email);
}

export function individualSignupCreateLogin (request: IndividualLoginAccountRequest) {
  return authorizedAxios.post(userResource.individualSignupCreateLogin(), request);
}

export function individualSignupLoginEvent () {
    return authorizedAxios.put(userResource.individualSignupLoginEvent());
}

export function getLegalContributionLimitsByPlanType () {
    return authorizedAxios.get(userResource.legalContributionLimitsByPlanType());
}

export function savePlanDetails (details: PlanDetails) {
    return authorizedAxios.post(userResource.planDetails(), details);
}

export function getPlanType () {
    return authorizedAxios.get<UserPlanType>(userResource.planType());
}

export function updatePlanType (data: UserPlanTypeUpdate) {
    return authorizedAxios.post<UserPlanTypeUpdate>(userResource.planType(), data);
}

export function getPlanDetails (username: string, partnerId: number) {
    const query = (username) ? { forUser: username, forUserPartnerId: partnerId } : undefined;
    return authorizedAxios.get(userResource.planDetails(), query);
}

export function getUserCoverageLevels () {
    return authorizedAxios.get<UserCoverageLevels>(userResource.userCoverageLevels());
}

export function updateUserCoverageLevels (request: UserCoverageLevels) {
    return authorizedAxios.post<UserCoverageLevelUpdateResponse>(userResource.userCoverageLevels(), request);
}

export function contributionLimits (username: string, partnerId: number) {
    const query = (username) ? { forUser: username, forUserPartnerId: partnerId } : undefined;
    return authorizedAxios.get<ContributionLimitResponse>(userResource.contributionLimits(), query);
}

export function saveOtherHsaAmount (otherHsa: OtherHsaAmountModel) {
    return authorizedAxios.post(userResource.otherHsaAmount(), otherHsa);
}

export function getOtherHsaAmounts (username: string, partnerId: number) {
    const query = (username) ? { forUser: username, forUserPartnerId: partnerId } : undefined;
    return authorizedAxios.get(userResource.otherHsaAmount(), query);
}

export function getPartnerUsers (partnerUserRequest: PartnerUserRequest) {
    return authorizedAxios.get<PartnerUsersResponse>(
        userResource.getPartnerUsers(partnerUserRequest.partnerId,
            partnerUserRequest.pageNumber,
            partnerUserRequest.searchFirstname,
            partnerUserRequest.searchLastname,
            partnerUserRequest.searchEmail,
            partnerUserRequest.searchRole));
}
export function updatePartnerUser (partnerId: number, partnerUser: PartnerUser) {
    return authorizedAxios.put<PartnerUserSaveResponse>(userResource.savePartnerUser(partnerId), partnerUser);
}

export function updatePartnerUserData (partnerId: number, partnerUser: PartnerUser) {
    return authorizedAxios.put<PartnerUserSaveResponse>(userResource.updatePartnerUserData(partnerId), partnerUser);
}

export function adminPartners () {
    return authorizedAxios.get<PartnerGetResponse>(userResource.adminPartners());
}

export function generateEmbed (id: string) {
    return authorizedAxios.post<{EmbedUrl: string}>(userResource.reportEmbed(id));
}

export function adminPartner (partnerId: number) {
    return authorizedAxios.get<PartnerSaveResponse>(userResource.adminPartner(partnerId));
}

export function adminPartnerSettingsSet (partnerId: number, request: PartnerSettingsRequest) {
    return authorizedAxios.post(userResource.adminPartnerSettings(partnerId), request);
}

export function adminSftpTestFiles () {
    return authorizedAxios.get<AdminSftpTestFilesList>(userResource.adminSftpTestFiles());
}

export function adminSftpTestFileDownload (request: AdminSftpTestFileDownload) {
    return authorizedAxios.postFile(userResource.adminSftpTestFilesDownload(), request);
}

export function adminPartnerSettingsGet (partnerId: number) {
    return authorizedAxios.get<PartnerSettingsResponse>(userResource.adminPartnerSettings(partnerId));
}

export function employerPartnerSettingsGet (partnerId: number, employerId: number) {
    return authorizedAxios.get<PartnerSettingsResponse>(userResource.employerPartnerSettings(partnerId, employerId));
}

export function adminSavePartner (partnerSave: PartnerSave) {
    return authorizedAxios.put<PartnerSaveResponse>(userResource.adminPartners(), partnerSave);
}

export function partnerCreateEmployer (partnerId: number, employerName: string, externalEmployerId: string) {
    return authorizedAxios.post<EmployerCreateResponse>(
        userResource.partnerAddEmployer(partnerId),
        { employerName, externalEmployerId});
}

export function getPartnerAsset (partnerId: number, assetType: AssetType) {
    return authorizedAxios.get<any>(userResource.partnerAsset(partnerId, assetType));
}

export function savePartnerSupportInfo (partnerId: number, supportInfo: SupportInfo) {
    return authorizedAxios.put(userResource.PartnerSupportInfo(partnerId), supportInfo);
}

export function savePartnerAsset (partnerId: number, assetType: AssetType, logoFile: any ) {
    return authorizedAxios.postFiles(userResource.partnerAsset(partnerId, assetType), [logoFile]);
}

export function deletePartnerAsset (partnerId: number, assetType: AssetType) {
    return authorizedAxios.delete(userResource.partnerAsset(partnerId, assetType));
}

export function enableUserAccount (request: AccountEnableDisableRequest) {
    return authorizedAxios.post<CognitoAccountEnableDisableResult>(userResource.userAccountEnable(), request);
}

export function disableUserAccount (request: AccountEnableDisableRequest) {
    return authorizedAxios.post<CognitoAccountEnableDisableResult>(userResource.userAccountDisable(), request);
}

export function changeUserEmail (fromEmail: string, toEmail: string) {
    return authorizedAxios.post<void>(userResource.resetUserEmail(), { currentEmail: fromEmail, newEmail: toEmail });
}

export function getUserById (userId: number) {
    return authorizedAxios.get<UserSearchResultModel>(userResource.getUserById(userId));
}

export function loadUsers (pageNumber: number, pageSize: number, searchTerm: string) {
    return authorizedAxios.get<UserSearchResultList>(userResource.getUsers(pageNumber, pageSize, searchTerm));
}

export function saveAdminDobNameChange (userDobName: UserDobNameModel) {
    return authorizedAxios.post<void>(userResource.saveAdminDobNameChange(), userDobName);
}

export function downloadEmployeeBankInfoReport (employerId: number) {
    return authorizedAxios.get(userResource.downloadEmployeeBankInfoReport(employerId));
}

export function downloadCensusFileResult (employerId: number, censusFileId: number) {
    return authorizedAxios.get(userResource.downloadCensusResultFile(employerId, censusFileId));
}
export function partnerEmployersSearch (
    partnerId: number,
    pageNumber: number,
    pageSize: number,
    sortBy: string,
    sortOrder: string,
    searchTerm: PartnerEmployersSearchFields) {
    return authorizedAxios.get<PartnerEmployersResponse>(
        userResource.partnerEmployersSearch(partnerId), {
            page: pageNumber,
            pageSize,
            sortOption: sortBy,
            sortOrder,
            employerName: searchTerm.employerName,
            employerId: searchTerm.employerId,
            taxId: searchTerm.taxId,
            externalEmployerId: searchTerm.externalEmployerId});
}

export function partnerEmployers (partnerId: number) {
    return authorizedAxios.get<PartnerEmployersResponse>(userResource.partnerEmployers(partnerId));
}

export function partnerEmployer (partnerId: number, employerId: number) {
    return authorizedAxios.get<PartnerEmployer>(userResource.partnerEmployer(partnerId, employerId));
}

export function getEmployeeSearchResults (
    partnerId: number,
    searchTerms: EmployeeSearchTerm,
    page: number,
    pageSize: number) {
    return authorizedAxios.post<EmployeeSearchResults>(
        userResource.getEmployeeSearchResults(partnerId), {searchTerms, page, pageSize});
}

export function getAdminParticipantSearchResults (
    searchTerms: EmployeeSearchTerm,
    page: number,
    pageSize: number) {
    return authorizedAxios.post<EmployeeSearchResults>(
        userResource.getAdminParticipantSearchResults(), {searchTerms, page, pageSize });
}

export function downloadFraudPreventionReport () {
    return authorizedAxios.get(userResource.downloadFraudPreventionReport());
}

export function downloadDemoUsersReport () {
    return authorizedAxios.get(userResource.downloadDemoUsersReport());
}
export function getAdminEmailTemplates () {
    return authorizedAxios.get<EmailTemplate[]>(userResource.getAdminEmailTemplates());
}
export function getAdminEmailTemplateDetail (templateName: string) {
    return authorizedAxios.get<EmailTemplateDetail>(userResource.getAdminEmailTemplateDetail(templateName));
}

export function putRevealPersonalInformation (request: RevealPersonalInformationRequest) {
    return authorizedAxios.put<RevealPersonalInformationResponse>(userResource.putRevealPersonalInformation(), request);
}

export function putAdminPortalRevealPersonalInformation (request: RevealPersonalInformationRequest) {
    return authorizedAxios.put<RevealPersonalInformationResponse>(userResource.putAdminPortalRevealPersonalInformation(), request);
}

export function getEmployeeSearchList (employerId: number, searchTerm: string) {
    return authorizedAxios.get<EmployeeSearchDropdownItem[]>(userResource.getEmployeeSearchList(employerId, searchTerm));
}

export function getBirthYear () {
    return authorizedAxios.get<BirthYearResponse>(userResource.getBirthYear());
}

export function getHsaStoreInfo (partnerId: number) {
    return authorizedAxios.get<PartnerHsaStoreInfo>(userResource.hsaStoreInfo(partnerId));
}

export function getEmployeeLogoutRedirect (partnerId: number) {
    return authorizedAxios.get<string>(userResource.logoutRedirect(partnerId));
}

export function sendIndividualSignupEmailClick (username: string) {
    return axios.post(userResource.individualSignupEmailClick(), { username });
}

export function getCommunicationKitType (partnerId: number) {
    return authorizedAxios.get<CommunicationKitType>(userResource.communicationKitType(partnerId));
}

export function savePartnerStoreInfo (partnerId: number, request: PartnerHsaStoreInfo) {
    return authorizedAxios.put<PartnerHsaStoreInfo>(userResource.hsaStoreInfo(partnerId), request);
}

export function sendMfaStatus (status: MfaStatusEnum, phoneNumber: string) {
    return authorizedAxios.get<boolean>(userResource.sendMfaStatus(status, phoneNumber));
}

export function setMfaPreference (value: boolean) {
    return authorizedAxios.get<boolean>(userResource.setMfaPreference(value));
}

export function getSalesPersons () {
    return authorizedAxios.get<SalesPerson[]>(userResource.getSalesPersons());
}

export function saveSalesPerson (salesPerson: SalesPerson | object) {
    return authorizedAxios.post<boolean>(userResource.saveSalesPerson(), salesPerson);
}

export function getTerminationReasons () {
    return authorizedAxios.get<TerminationReason[]>(userResource.terminationReasons());
}

export function getEmployerRolePermissions () {
    return authorizedAxios.get<EmployerRolePermission[]>(userResource.employerRolePermissions());
}

export function saveEmployerRolePermissions (request: EmployerRolePermission[]) {
    return authorizedAxios.post<boolean>(userResource.employerRolePermissions(), request);
}

export function updatePartnerNotificationEmail (partnerId: number, request: PartnerEmailResponse) {
    return authorizedAxios.post<boolean>(userResource.partnerNotificationEmail(partnerId), request);
}

export function getPartnerNotificationEmail (partnerId: number) {
    return authorizedAxios.get<PartnerEmailResponse>(userResource.partnerNotificationEmail(partnerId));
}

export function requestDisableMfa (request: MfaAdminDisableRequest) {
    return authorizedAxios.post(userResource.requestDisableMfa(), request);
}

export function disableMfaWithCode (request: MfaUserDisableRequest) {
    return authorizedAxios.post(userResource.disableMfaWithCode(), request);
}

export function employerUpdateCensusSetting (employerId: number) {
    return authorizedAxios.get<boolean>(userResource.employerUpdateCensusSetting(employerId));
}

export function updateCensusManager (employerId: number, request: UpdateCensusManagerRequest) {
    return authorizedAxios.post<boolean>(userResource.censusManager(employerId), request);
}

export function getPartnerSettings () {
    return authorizedAxios.get<UserPartnerSettings>(userResource.getPartnerSettings());
}

export function getEmployerCensusFiles (employerId: number, pageNumber: number,  pageSize: number) {
    return authorizedAxios.get<EmployerCensusFileResponse>(userResource
        .getEmployerCensusFiles(employerId, pageNumber, pageSize));
}

export function getEmployerCensusFileDetails (employerId: number, censusFileId: number) {
    return authorizedAxios.get<EmployerCensusFileDetailsResponse>(userResource
        .getEmployerCensusFileDetails(employerId, censusFileId));
}

export function getEmployeeIdFiles (employerId: number, pageNumber: number,  pageSize: number) {
    return authorizedAxios.get<EmployeeIdFileResponse>(userResource
        .getEmployeeIdFiles(employerId, pageNumber, pageSize));
}

export function processEmployeeIdUpdateFile (employerId: number, csv: any ) {
    return authorizedAxios.postFiles(userResource.postEmployeeIdUpdateFile(employerId), [csv]);
}

export function downloadEmployeeIdUpdateFileResult (employerId: number, employeeIdFileId: number) {
    return authorizedAxios.get(userResource.fetchEmployeeIdUpdateFile(employerId, employeeIdFileId));
}

export function getRolePermissions () {
    return authorizedAxios.get<RolePermissionsResponse>(userResource.getRolePermissions());
}

export function updateEmployerUser (employerId: number, request: EmployerUser) {
    return authorizedAxios.post<EmployerUser>(userResource
        .updateEmployerUser(employerId, request.employerUserId), request);
}

export function getQuickSightReport () {
    return authorizedAxios.get<QuickSightReport[]>(userResource.quickSightReport());
}

export function getEmployerQuickSightReports (employerId: number) {
    return authorizedAxios.get<QuickSightUserReportsApiResponse>(userResource.getEmployerReports(employerId));
}

export function getPartnerQuickSightReports (partnerId: number) {
    return authorizedAxios.get<QuickSightUserReportsApiResponse>(userResource.getPartnerReports(partnerId));
}

export function deleteQuickSightReport (reportId: number) {
    return authorizedAxios.delete<void>(userResource.quickSightReportById(reportId));
}

export function saveQuickSightReport (request: QuickSightReport) {
    return authorizedAxios.post<boolean>(userResource.quickSightReport(), request);
}

export function getUserRoles () {
    return authorizedAxios.get<UserRoleModel[]>(userResource.getUserRoles());
}

export function getUserRolesByType (roleType: string) {
    return authorizedAxios.post<UserRoleModel[]>(userResource.getUserRolesByType(roleType));
}

export function getRolesByType (roleType: string) {
    return authorizedAxios.post<UserRoleModel[]>(userResource.getRolesByType(roleType));
}

export function createUserRole (role: UserRoleModel) {
    return authorizedAxios.post<UserRoleModel>(userResource.createUserRole(), role);
}

export function updateRole (role: UserRoleModel) {
    return authorizedAxios.post<UserRoleModel>(userResource.updateRole(), role);
}

export function getUserRoleById (roleId: number) {
    return authorizedAxios.get<UserRoleModel>(userResource.getUserRoleById(roleId));
}

export function UpdatePermissionsByRole (role: UserRoleModel) {
    return authorizedAxios.post<UserRoleModel>(userResource.UpdatePermissionsByRole(), role);
}

export function getReportCategories () {
    return authorizedAxios.get<ReportCategory[]>(userResource.getReportCategories());
}

export function getTestUsers () {
    return authorizedAxios.get<TestUser[]>(userResource.getTestUsers());
}

export function getSigningDocuments () {
    return authorizedAxios.get<SigningDocument[]>(userResource.signingDocumentList());
}

export function getSigningDocument (documentKey: string, version: number) {
    return authorizedAxios.get<SigningDocument>(userResource.getSigningDocument(documentKey, version));
}

export function getSigningDocumentAdmin (documentKey: string, version: number) {
    return authorizedAxios.get<SigningDocument>(userResource.getSigningDocumentAdmin(documentKey, version));
}

export function getSigningDocumentById (documentId: number, version: number) {
    return authorizedAxios.get<SigningDocument>(userResource.getSigningDocumentById(documentId, version));
}

export function getSigningDocumentByIdAdmin (documentId: number, version: number) {
    return authorizedAxios.get<SigningDocument>(userResource.getSigningDocumentByIdAdmin(documentId, version));
}

export function getDocumentLatestVersion (documentKey: string) {
    return authorizedAxios.get<SigningDocument>(userResource.getDocumentLatestVersion(documentKey));
}

export function getDocumentLatestVersionAdmin (documentKey: string) {
    return authorizedAxios.get<SigningDocument>(userResource.getDocumentLatestVersionAdmin(documentKey));
}
export function resyncTalonClaims (r: ResyncTalonClaimsRequest) {
    return authorizedAxios.post(userResource.resyncTalonClaims(r.partnerId), r);
}
export function getUserSignedDocumentKey (accountType: string) {
    return authorizedAxios.get<SigningDocument>(userResource.getUserSignedDocumentKey(accountType));
}

export function getUserSignedDocumentKeyAdmin () {
    return authorizedAxios.get<SigningDocument>(userResource.getUserSignedDocumentKeyAdmin());
}

export function getSignature (documentKey: string) {
    return authorizedAxios.get<DocumentSignature>(userResource.getSignature(documentKey));
}

export function saveSigningDocument (request: SigningDocument) {
    return authorizedAxios.post<number>(userResource.signingDocuments(), request);
}

export function saveFile (request: SigningDocument, file: any) {
    return authorizedAxios.postFiles<number>(userResource.saveFile(), [file], request);
}

export function deleteSignature (key: string) {
    return authorizedAxios.delete(userResource.deleteSignature(key));
}

export function markDeleteSignature (key: string) {
    return authorizedAxios.put(userResource.markDeleteSignature(key));
}

export function saveSignature (request: DocumentSaveSignatureRequest) {
    return authorizedAxios.post(userResource.saveSignature(), request);
}
export function getOpenSearchDomainDetails () {
    return authorizedAxios.get<OpenSearchDomainDetail>(userResource.openSearchDomainDetails());
}
export function getSearchCapability () {
    return authorizedAxios.get<SearchCapability>(userResource.getSearchCapability());
}
export function getOpenSearchIndexInfo () {
    return authorizedAxios.get<OpenSearchIndex>(userResource.openSearchAdminIndexes());
}
export function putOpenSearchIndexRequest (request: OpenSearchIndexRequest) {
    return authorizedAxios.put<OpenSearchIndex>(userResource.openSearchAdminIndexes(), request);
}
export function uploadSynonymFile (txt: File ) {
    return authorizedAxios.postFiles<OpenSearchPackagesResponse>(userResource.uploadSynonymFile, [txt]);
}
export function openSearchReindexUser (cognitoUsername: string) {
    return authorizedAxios.post<string>(userResource.openSearchReindexUser(cognitoUsername));
}
export function openSearchReindexEmployer (employerId: number) {
    return authorizedAxios.post<string>(userResource.openSearchReindexEmployer(employerId));
}
export function openSearchGetEmployerDocument (employerId: number) {
    return authorizedAxios.get<EmployerSearchDocument>(userResource.openSearchGetEmployerDocument(employerId));
}
export function openSearchGetUserDocument (cognitoUsername: string) {
    return authorizedAxios.get<UserSearchDocument>(userResource.openSearchGetUserDocument(cognitoUsername));
}
export function getMonitoredStateMachines (maxHistoryCount: number) {
    return authorizedAxios.get<StateMachineExecutionHistory[]>(userResource.getMonitoredStateMachines(maxHistoryCount));
}
export function getCommunication (id: number) {
    return authorizedAxios.get(userResource.getCommunication(id));
}

export function getEmployeeCommunications (isMobile = false, accountTypes = [],
                                           dashboard = CommunicationDashboard.Hsa) {
    const client = isMobile ? CommunicationClient.Mobile : CommunicationClient.Web;
    const request = { client, accountTypes, dashboard };
    return authorizedAxios.get(userResource.getEmployeeCommunications(), request);
}

export function getEmployerCommunications (employerId: number) {
    return authorizedAxios.get(userResource.getEmployerCommunications(employerId));
}

export function loadPartnerCommunications (partnerId: number, portal: CommunicationPortal) {
    return authorizedAxios.get<Communication>(userResource.partnerCommunicationsForPortal(partnerId, portal));
}

export function loadEmployerCommunications (employerId: number, portal: CommunicationPortal) {
    return authorizedAxios.get<Communication>(userResource.employerCommunicationsForPortal(employerId, portal));
}

export function postPartnerCommunication (partnerId: number, portal: CommunicationPortal, communication: Communication) {
    return authorizedAxios.post<SaveCommunication>(userResource.partnerCommunicationsForPortal(partnerId, portal), communication);
}
export function getEmployerTypeAhead (partnerId: number, searchTerm: string) {
    return authorizedAxios.get<EmployerTypeAheadResponse>(userResource.getEmployerTypeAhead(partnerId, searchTerm));
}
export function saveCommunicationImage (partnerId: number, communicationId: number, imageFile: any) {
    return authorizedAxios.postFiles(userResource.communicationImage(partnerId, communicationId), imageFile);
}
export function getCommunicationImageUrl (partnerId: number, communicationId: number) {
    return authorizedAxios.get<string>(userResource.communicationImage(partnerId, communicationId));
}

export function removeCommunicationImage (partnerId: number, communicationId: number) {
    return authorizedAxios.delete(userResource.communicationImage(partnerId, communicationId));
}
export function getPartnerCommunicationEmployers (partnerId: number) {
    return authorizedAxios.get<PartnerEmployerList>(userResource.partnerCommunicationEmployers(partnerId));
}
export function saveUserEvent (userEventModel: any) {
    return authorizedAxios.post(userResource.userEvent(), userEventModel);
}
export function userLoginEvent () {
    return authorizedAxios.put(userResource.userLoginEvent());
}
export function saveUserEmailUpdate (username: string, email: string, partnerId: number) {
    return authorizedAxios.put(userResource.userEmailUpdate(partnerId), { username, email });
}
export function getPartnerContent (partnerId: number) {
    return authorizedAxios.get<Record<PartnerContentType, string>>(userResource.partnerContent(partnerId));
}

export function getUserPartnerContent (contentType: PartnerContentType) {
    return authorizedAxios.get<string>(userResource.userPartnerContent(contentType));
}

export function getPartnerContentDisplay (partnerId: number, contentType: PartnerContentType) {
    return authorizedAxios.get<string>(userResource.partnerContentDisplay(partnerId, contentType));
}

export function savePartnerContent (partnerId: number, content: Record<PartnerContentType, string>) {
    return authorizedAxios.post(userResource.partnerContent(partnerId), content);
}

export function isPasswordPwned (passwordSha1: string) {
    return authorizedAxios.post(userResource.pwned(), {hashedPassword: passwordSha1});
}

export function getAutomatedFundingOptionLeaveDate (employerId: number) {
    return authorizedAxios.get<string>(userResource.automatedFundingOptionLeaveDate(employerId));
}

export function resetUserCustodian (request: ResetUserCustodianRequest) {
    return authorizedAxios.put<void>(userResource.resetUserCustodian(), request);
}

export function resetPassword (emailAddress: string) {
    return authorizedAxios.post<{ password: string}>(userResource.resetPassword(), { emailAddress });
}

export function getOutageNotification () {
    return authorizedAxios.get<OutageNotification>(userResource.outageNotification());
}

export function postOutageNotification (request: OutageNotification) {
    return authorizedAxios.post(userResource.outageNotification(), request);
}

export function identityProofingOptions (username: string) {
    return authorizedAxios.get<IdentityProofingOptionsResponse>(userResource.identityProofingOptions(username));
}

export function identityProofingChallenge (request: IdentityProofChallengeRequest) {
    return authorizedAxios.post<IdentityProofChallengeResponse>(userResource.identityProofingChallenge(), request);
}

export function mfaEmailChallenge (request: MfaEmailChallengeRequest) {
    return authorizedAxios.post<MfaEmailChallengeResponse>(userResource.mfaEmailChallenge(), request);
}

export function mfaEmailVerify (request: MfaEmailVerifyRequest) {
    return authorizedAxios.post<UserContactVerifiedResponse>(userResource.mfaEmailVerify(), request);
}

export function sendHsabEmailChangeVerificationCode (request: HsabEmailChangeRequest) {
    return authorizedAxios.post<HsabEmailChangeResponse>(userResource.sendHsabEmailChangeVerificationCode(), request);
}

export function verifyHsabEmailChange (request: HsabEmailChangeVerifyRequest) {
    return authorizedAxios.post<HsabEmailChangeVerifyResponse>(userResource.verifyHsabEmailChange(), request);
}

export function identityProofingVerify (request: IdentityProofVerifyRequest) {
    return authorizedAxios.post<UserContactVerifiedResponse>(userResource.identityProofingVerify(), request);
}

export function identityProofingDataVerify (request: IdentityProofDataVerifyRequest) {
    return authorizedAxios.post<UserContactVerifiedResponse>(userResource.identityProofingDataVerify(), request);
}

export function claimHsabAccount (request: ClaimHsabAccountRequest) {
    return authorizedAxios.post(userResource.claimHsabAccount(), request);
}

export function claimLoginEvent () {
    return authorizedAxios.put(userResource.claimLoginEvent());
}

export function idpInfoProfile (partnerId: number, username: string) {
    return authorizedAxios.get<UserAccountCredentialsResponse>(userResource.idpInfoProfile(partnerId, username));
}

export function idpInfoChangeStatus (changeStatusRequest: IdpStatusChangeRequest) {
    return authorizedAxios.post<UserAccountCredentialsResponse>(
        userResource.idpInfoChangeStatus(changeStatusRequest.partnerId),
        changeStatusRequest);
}

export function idpInfoChangeSuspendStatus (changeStatusRequest: IdpStatusChangeRequest) {
    return authorizedAxios.post<UserAccountCredentialsResponse>(
        userResource.idpInfoChangeSuspendStatus(changeStatusRequest.partnerId),
        changeStatusRequest);
}

export function sendIdpEmailVerificationMessage (emailChangeRequest: IdpEmailChangeRequest) {
    return authorizedAxios.post<UserAccountCredentialsResponse>(
        userResource.sendIdpEmailVerificationMessage(emailChangeRequest.partnerId),
        emailChangeRequest);
}

export function verifyIdpEmailChange (verifyIdpEmailChangeRequest: VerifyIdpEmailChangeRequest): any {
    return authorizedAxios.post(userResource.verifyIdpEmailChange(), verifyIdpEmailChangeRequest);
}

export function oktaForgotPassword (username: string) {
    return authorizedAxios.post(userResource.oktaForgotPassword(), { username });
}

export function oktaAccountExists (username: string) {
    return authorizedAxios.get<OktaAccountCheckResponse>(userResource.oktaAccountExists(username));
}

export function oktaFactors () {
    return authorizedAxios.get<OktaFactor[]>(userResource.oktaFactors());
}

export function enrollFactor (request: OktaEnrollFactorRequest) {
    return authorizedAxios.post<OktaEnrollFactorResponse>(userResource.enrollFactor(), request);
}

export function revert (oktaRevertFactorRequest: OktaRevertFactorRequest) {
    return authorizedAxios.post<OktaEnrollFactorResponse>(userResource.revert(), oktaRevertFactorRequest);
}

export function activateFactor (factorId: string, passCode: string) {
    return authorizedAxios.post(userResource.activateFactor(factorId), { passCode });
}

export function resetOktaFactor (factorId: string) {
    return authorizedAxios.delete(userResource.resetFactor(factorId));
}

export function removeOktaFactor (factorId: string) {
    return authorizedAxios.delete(userResource.oktaFactor(factorId));
}

export function oktaForgotUsername (forgotUsernameRequest: ForgotUsernameRequest) {
    return authorizedAxios.post<ForgotUsernameResponse>(userResource.oktaForgotUsername(), forgotUsernameRequest);
}

export function getEmploymentStatus (cognitoUsername: string) {
    return authorizedAxios.get<EmploymentStatusResponse>(userResource.getEmploymentStatus(cognitoUsername));
}

export function mobileAppAccessCheck (appIdentifier: string, username: string) {
    return authorizedAxios.get<MobileAppAccessCheckResponse>(userResource.mobileAppAccessCheck(appIdentifier, username));
}

export function mobileAppVersionCheck (appIdentifier: string) {
    return authorizedAxios.get<MobileAppVersion>(userResource.mobileAppVersionCheck(appIdentifier));
}

export function searchMobileApps (request: MobileAppSearchRequest) {
    return authorizedAxios.post<MobileAppSearchResponse>(userResource.searchMobileApps(), request);
}

export function getMobileApp (appId: number) {
    return authorizedAxios.post<MobileApp>(userResource.getMobileApp(appId));
}

export function updateMobileApp (request: MobileApp) {
    return authorizedAxios.post<MobileApp>(userResource.updateMobileApp(), request);
}

export function createMobileApp (request: MobileApp) {
    return authorizedAxios.post<MobileApp>(userResource.createMobileApp(), request);
}

export function deleteMobileApp (appId: number) {
    return authorizedAxios.delete(userResource.deleteMobileApp(appId));
}

export function validateUsername (request: UsernameValidateRequest) {
    return authorizedAxios.post(userResource.validateUsername(), request);
}

export function getEmployerAsset (employerId: number, assetType: AssetType) {
    return authorizedAxios.get<any>(userResource.employerAsset(employerId, assetType));
}

export function saveEmployerAsset (employerId: number, assetType: AssetType, logoFile: any ) {
    return authorizedAxios.postFiles(userResource.employerAsset(employerId, assetType), [logoFile]);
}

export function deleteEmployerAsset (employerId: number, assetType: AssetType) {
    return authorizedAxios.delete(userResource.employerAsset(employerId, assetType));
}

export function getUserAsset (partnerId: number, employerId: number, assetType: AssetType) {
    return authorizedAxios.get<any>(userResource.userAsset(partnerId, employerId, assetType));
}

export function putSsoLinkClick (location: HsaBankSsoLocationName) {
    return authorizedAxios.put<HsabSsoLocationResponse>(userResource.SsoLinkClick(), location);
}

export function getSsoLink () {
    return authorizedAxios.get<HsabSsoLocationResponse>(userResource.GetSsoLink());
}

export function getSupportInfo (partnerId: number, employerId: number) {
    return authorizedAxios.get<SupportInfo>(userResource.getSupportInfo(partnerId, employerId));
}

export function saveEmployerSupportInfo (employerId: number, supportInfo: SupportInfo) {
    return authorizedAxios.put(userResource.saveEmployerSupportInfo(employerId), supportInfo);
}

export function getLobSuggestions (request: LobAutoCompleteAddressRequest) {
    return authorizedAxios.post<{ suggestions: any}>(userResource.lobAutocomplete(), request);
}

export function lobAddressVerification (request: LobAddressValidationRequest) {
    return authorizedAxios.post<LobAddressValidationResponse>(userResource.lobVerify(), request);
}

export function getEmailHistory (email: string) {
    return authorizedAxios.get<SupportInfo>(userResource.getEmailHistory(), { email });
}

export function getEmailHistoryRawEventData (id: number) {
    return authorizedAxios.get<SupportInfo>(userResource.getEmailHistoryRawEventData(id));
}

export function removeEmailFromBounceList (emailAddress: string) {
    return authorizedAxios.post(userResource.removeEmailFromBounceList(), { emailAddress });
}

export function updateUserIdpUsername (username: string) {
    return authorizedAxios.post(userResource.updateUserIdpUsername(), { username });
}

export function updateUserIdpPassword (request: PasswordChangeRequest) {
    return authorizedAxios.post(userResource.updateUserIdpPassword(), request);
}

export function shouldShowEmployerSignupQuestion (partnerId: number) {
    return authorizedAxios.get<PartnerShowEmployerSignupQuestion>(userResource.shouldShowEmployerSignupQuestion(partnerId));
}

export function resetUserIdpAccount (bendUserId: string, partnerId: number) {
    return authorizedAxios.post<UserAccountCredentialsResponse>(userResource.resetUserIdpAccount(partnerId), { bendUserId });
}

export function enableUserIdpAccount (bendUserId: string, partnerId: number) {
    return authorizedAxios.post<UserAccountCredentialsResponse>(userResource.enableUserIdpAccount(partnerId), { bendUserId });
}

export function syncUserIdpAccount (bendUserId: string, partnerId: number) {
    return authorizedAxios.post(userResource.syncUserIdpAccount(partnerId), { bendUserId });
}

export function ebtoGetCampaign (campaignKey: string) {
    return authorizedAxios.get<EbtoCampaign>(userResource.ebtoGetCampaign(campaignKey));
}

export function ebtoClaimUserCampaign (request: EbtoRequest) {
    return authorizedAxios.post<EbtoResponse>(userResource.ebtoClaimUserCampaign(request.campaignId), request);
}

export function ebtoSendConfirmationEmailStay (request: EbtoEmailRequest) {
    return authorizedAxios.post(userResource.ebtoSendConfirmationEmail(request.campaignId), request);
}

export function acceptEbtoPricingOffer (campaignId: string) {
    return authorizedAxios.post<EbtoResponse>(userResource.ebtoAcceptPricingOffer(campaignId));
}

export function ebtoFinalizeOffer (campaignId: string, request: EbtoUserFinalizeRequest) {
    return authorizedAxios.post<boolean>(userResource.ebtoFinalizeOffer(campaignId), request);
}

export function getCampaigns () {
    return authorizedAxios.get<CampaignDataModel[]>(userResource.getCampaigns());
}

export function ebtoEmployerSearch (searchTerm: string) {
    return authorizedAxios.get<EbtoEmployerSearchResult[]>(userResource.ebtoEmployerSearch(searchTerm));
}

export function ebtoCreateCampaign ( request: CreateTransferOutCampaignRequest ) {
    return authorizedAxios.post<boolean>(userResource.ebtoCreateCampaign(), request);

}

export function ebtoUpdateCampaign ( request: CreateTransferOutCampaignRequest ) {
    return authorizedAxios.post<boolean>(userResource.ebtoUpdateCampaign(), request);

}

export function getCampaignDetails (campaignKey: string) {
    return authorizedAxios.get<any>(userResource.getCampaignDetails(campaignKey));
}

export function ebtoResendVerificationCode (campaignKey: string, userId: string, verificationType: number) {
    return authorizedAxios.post<boolean>(userResource.ebtoResendVerificationCode(campaignKey, userId, verificationType));
}

export function ebtoVerifyUser (campaignKey: string, request: EbtoVerifyUserRequest) {
    return authorizedAxios.post<boolean>(userResource.ebtoVerifyUser(campaignKey), request);
}

export function eplLookupItem (productCode: string, method: EplLookupMethod) {
    return authorizedAxios.get<EplResponse>(userResource.eplLookupItem(productCode, method));
}

export function getCampaignRetentionDetails (campaignKey: string) {
    return authorizedAxios.get<any>(userResource.getCampaignRetentionDetails(campaignKey));
}

export function getLoginHistory (partnerId: number, username: string) {
    return authorizedAxios.get<LoginHistoryResponse>(userResource.getLoginHistory(partnerId, username));
}

export function getScannerLicense () {
    return authorizedAxios.get<ScannerLicenseResponse>(userResource.getScannerLicense());
}

export function getUserPermissions () {
    return authorizedAxios.get<RolePermissionsResponse>(userResource.getUserPermissions());
}

export function getUserFeedbackTriggers () {
    return authorizedAxios.get<UserFeedbackTriggerModel>(userResource.userFeedback());
}

export function saveUserFeedback (request: UserFeedbackSaveRequest) {
    return authorizedAxios.post(userResource.userFeedback(), request);
}

export function getFileUploadCategories () {
    return authorizedAxios.get<FileUploadCategoryResponse>(userResource.getFileUploadCategories());
}

export function uploadFiles (category: FileUploadCategory, accountNumber: string, files: File[]) {
    return authorizedAxios.postFiles<FileUploadResponse>(userResource.uploadFiles(category, accountNumber), files);
}

export function createAdminUser (request: CreateAdminUserRequest) {

    return authorizedAxios.post<UserCreateResponse>(userResource.createAdminUser(), request);
}

export function updateAdminUser (request: UpdateAdminUserRequest) {

    return authorizedAxios.post<UserCreateResponse>(userResource.updateAdminUser(), request);
}

export function syncAdminUser (userId: number) {

    return authorizedAxios.post<UserCreateResponse>(userResource.syncAdminUser(userId));
}

export function updateEmployerSsoUserSyncStatus (employerId: number, request: SsoUserSyncStatusModel) {
    return authorizedAxios.post(userResource.employerSsoUserSyncStatus(employerId), request);
}

export function getHsabEnrollmentSettings () {
    return authorizedAxios.get(userResource.hsabEnrollmentSettings());
}

export function getAdminPortalUsers () {
    return authorizedAxios.get<AdminPortalUser[]>(userResource.getAdminUser());
}
export function searchAdminPortalUsers (request: SearchAdminUsers) {
    return authorizedAxios.post<AdminUserResponse>(userResource.searchAdminUsers(), request);
}

export function activeAdminUser (changeStatusRequest: AdminUserStatusChangeRequest) {
    return authorizedAxios.post<UserAccountCredentialsResponse>(
        userResource.activeAdminUser(),
        changeStatusRequest);
}

export function deactivateAdminUser (changeStatusRequest: AdminUserStatusChangeRequest) {
    return authorizedAxios.post<UserAccountCredentialsResponse>(
        userResource.deactivateAdminUser(),
        changeStatusRequest);
}

export function revokeUserAccess (userId) {
    return authorizedAxios.post(
        userResource.revokeUserAccess(userId)
    );
}

export function resetPasswordAdminUser (changeStatusRequest: AdminUserStatusChangeRequest) {
    return authorizedAxios.post<UserAccountCredentialsResponse>(
        userResource.resetPasswordAdminUser(),
        changeStatusRequest);
}

export function unlockAdminUser (changeStatusRequest: AdminUserStatusChangeRequest) {
    return authorizedAxios.post<UserAccountCredentialsResponse>(
        userResource.unlockAdminUser(),
        changeStatusRequest);
}

export function resendActivationEmail (changeStatusRequest: AdminUserStatusChangeRequest) {
    return authorizedAxios.post<UserAccountCredentialsResponse>(
        userResource.resendActivationEmail(),
        changeStatusRequest);
}

export function getUserManagementRolePermissions () {
    return authorizedAxios.get<RolePermissionsResponse>(userResource.getUserManagementRolePermissions());
}

export function postPartnerBulkAddFile (file: any) {
    return authorizedAxios.postFiles(userResource.partnerBulkAddUpload(),
        [file]
    );
}

export function postPartnerBulkDeleteFile (file: any) {
    return authorizedAxios.postFiles(userResource.partnerBulkDeleteUpload(),
        [file]
    );
}

export function getBulkFiles (pageNumber: number, pageSize: number, fileType: number) {
    return authorizedAxios.get<PartnerUserBulkResponse>(userResource.partnerBulkGetFiles(pageNumber, pageSize, fileType));
}

export function searchBulkFiles (pageNumber: number, pageSize: number, fileType: number, fileName: string, status: BulkFileUploadStatus, startDate: string, endDate: string) {
    return authorizedAxios.get<PartnerUserBulkResponse>(userResource.partnerSearchBulkFiles(pageNumber, pageSize, fileType, fileName, status, startDate, endDate));
}

export function downloadPartnerUserBulkResultFile (partnerUserFileId) {
    return authorizedAxios.get(userResource.downloadPartnerUserBulkResultFile(partnerUserFileId));
}

export function getUserNotes (args?: { username: string, partnerId: number }) {
    const params = args ? { forUser: args.username, forUserPartnerId: args.partnerId } : undefined;
    return authorizedAxios.get<UserNotesResponse>(userResource.userNotes(), params);
}

export function getUserEmploymentInfo (args?: { username: string, partnerId: number }) {
    const params = args ? { forUser: args.username, forUserPartnerId: args.partnerId } : undefined;
    return authorizedAxios.get<UserEmploymentInfo>(userResource.userEmploymentInfo(), params);
}

export function confirmUser () {
    return authorizedAxios.post(userResource.userConfirmed());
}

export function getPartnerUserMfaOptions (partnerId: number, email: string) {
    return authorizedAxios.get<UserMfaOptions>(userResource.partnerUserMfaOptions(partnerId), { forUser: email });
}

export function resetPartnerUserMfaOptions (partnerId: number, email: string, mfaOptions: OktaFactorType[]) {
    return authorizedAxios.post(userResource.partnerUserMfaOptions(partnerId), { email, mfaOptions });
}

export function getUserInterestRates (args?: { username: string, partnerId: number }) {
    const params = args ? { forUser: args.username, forUserPartnerId: args.partnerId } : undefined;
    return authorizedAxios.get<UserInterestRates>(userResource.userInterestRates(), params);
}

export function getEmployerFeeSchedules (args?: { username: string, partnerId: number, offeringId: number}) {
    const params = args ? { forUser: args.username, forUserPartnerId: args.partnerId, offeringId: args.offeringId } : undefined;
    return authorizedAxios.get<EmployerFeeScheduleResponse>(userResource.employerFeeSchedules(), params);
}

export function getEmployerFeeSchedulesActiveForUser () {
    return authorizedAxios.get<EmployerFeeScheduleResponse>(userResource.employerFeeSchedulesActiveForUser());
}

export function getActiveEmployerFeeSchedules (employerId: number) {
  return authorizedAxios.get<EmployerActiveFeeSchedules>(userResource.activeEmployerFeeSchedules(employerId));
}

export function getEmployerInterestRates (employerId: number) {
  return authorizedAxios.get<UserInterestRates>(userResource.employerInterestRates(employerId));
}

export function getCountries () {
  return authorizedAxios.get<CountryList>(userResource.countries());
}

export function getUserDiscretionaryData () {
  return authorizedAxios.get<UserDiscretionaryData>(userResource.userDiscretionaryData());
}

export function updateUserDiscretionaryData (request: UserDiscretionaryData) {
  return authorizedAxios.put(userResource.userDiscretionaryData(), request);
}

export function getUserPersonalInfo () {
    return authorizedAxios.get<UserPersonalInfo>(userResource.userPersonalInfo());
}

export function getImportantDates (request: ImportantDateRequest) {
    return authorizedAxios.post(userResource.getImportantDates(), request);
}

export function generateTrusteeToTrusteeBalanceTransferForm (request: TrusteeToTrusteeBalanceTransferFormRequest) {
    return authorizedAxios.post<BalanceTransferFormResponse>(userResource.trusteeToTrusteeBalanceTransferForm(), request);
}

export function generateRolloverBalanceTransferForm (request: RolloverBalanceTransferFormRequest) {
    return authorizedAxios.post<BalanceTransferFormResponse>(userResource.rolloverBalanceTransferForm(), request);
}

export function getEmployerProducts (employerId: number) {
    return authorizedAxios.get<any>(userResource.getEmployerProducts(employerId), {
        params: {
            employerId
        }
    });
}

export function getMetricsWithContent (employerId: number, selectors: string[]) {
  return authorizedAxios.post<MetricContent[]>(
    userResource.getMetricsWithContent(employerId),
    selectors
  );
}

export function getMetricsWithGraphs (employerId: number, selectors: string[]) {
  return authorizedAxios.post<MetricContent[]>(
    userResource.getMetricsWithGraphs(employerId),
    selectors
  );
}

export function getDefaultPartnerBanners () {
    return authorizedAxios.get<PartnerBanner[]>(userResource.getDefaultPartnerBanners());
}

export function getCustomPartnerBanners (partnerId: number) {
    return authorizedAxios.get<PartnerBanner[]>(userResource.getCustomPartnerBanners(partnerId));
}

export function getPartnerBanners (employerId: number) {
    return authorizedAxios.get<PartnerBanner[]>(
        userResource.getPartnerBanners (employerId)
    );
}

export function createPartnerBanner (partnerId: number, banner: NewPartnerBanner) {
    return authorizedAxios.post<PartnerBanner>(
        userResource.createPartnerBanner(partnerId, banner),
        banner
    );
}

export function updatePartnerBanner (partnerId: number, bannerId: string, banner: PartnerBanner) {
    return authorizedAxios.put<PartnerBanner>(
        userResource.updatePartnerBanner(partnerId, bannerId, banner),
        banner
    );
}

export function deletePartnerBanner (partnerId: number, bannerId: string) {
    return authorizedAxios.delete<void>(
        userResource.deletePartnerBanner(partnerId, bannerId)
    );
}

export function updatePartnerBannerOrder (partnerId: number, bannerOrderRequest: UpdatePartnerBannerOrderRequest) {
    return authorizedAxios.put<PartnerBanner[]>(
        userResource.updatePartnerBannerOrder (partnerId, bannerOrderRequest),
        bannerOrderRequest
    );
}

export function getDisplayDefaultBanners (partnerId: number) {
    return authorizedAxios.get<any>(
        userResource.getDisplayDefaultBanners (partnerId)
    );
}

export function setDisplayDefaultBanners (partnerId: number, displayDefaultBannersRequest: DisplayDefaultBannersRequest) {
    return authorizedAxios.post<any>(
        userResource.setDisplayDefaultBanners (partnerId, displayDefaultBannersRequest),
        displayDefaultBannersRequest
    );
}

export function getPlanSettings (employerCode: string) {
    return authorizedAxios.get<PlanSetting[]>(
        userResource.getPlanSettings(employerCode)
    );
}

export function getWexEmployerProfile (wexEmployerCode, wexInstanceCode) {
    return authorizedAxios.get<EmployerProfileResponse>(userResource.wexEmployerProfile(), {
        employerCode: wexEmployerCode,
        wexInstanceCode
    });
}

export function saveWexEmployerProfile (request: EmployerProfileRequest) {
    return authorizedAxios.put<EmployerProfileUpdateResponse>(userResource.wexEmployerProfile(), request);
}

export function getSalesforceContacts (employerCode: string) {
    return authorizedAxios.get<HSARepResponse>(userResource.getSalesforceContacts(employerCode));
}